export const openSubscriptionManagementAction = async () => {
    window.open(import.meta.env.VITE_STRIPE_CUSTOMER_PORTAL_URL, '_blank');
};
